const React = require('react');
const { DataProvider } = require('@components/DataProvider');
require('@styles/global.scss');

exports.wrapPageElement = ({ element, props }) => {
  return <DataProvider value={props}>{element}</DataProvider>;
};

exports.onClientEntry = async () => {
  await require('@utils/polyfills');
};
